
import { Component, Vue } from "vue-property-decorator";

@Component({
    components: {
    }
})
export default class OpenTongueCollectStep3 extends Vue {

    viewReport() {
        this.$emit("viewReport");
    }

    tryAgain(){
        this.$emit("tryAgain");
    }
}
